module.exports = __webpack_public_path__ + "img/被袭倒下v2.60e958be.png";